import { Route } from "react-router-dom";
import { AccessKeysTable } from "../Pages/AccessKeys";
import Dashboard from "../Pages/DashBoard/Dashboard";
import { DigiSignSingle, SignTest } from "../Pages/DigitalSign";
import { DscTable } from "../Pages/Dsc";
import DscRegister from "../Pages/Dsc/DscRegister";
import { ProjectTable } from "../Pages/Projects";
import { Roles } from "../Pages/Roles";
import { UsersTable } from "../Pages/Users";
import MainLayout from "../themes/Main/Layout";
import PrivateRoute from "./PrivateRoute";

const DashRoutes = () => {
    return (
        <Route
            path="/auth/*"
            element={
                <PrivateRoute>
                    <MainLayout />
                </PrivateRoute>
            }
        >
          <Route index path="" element={<Dashboard />} /> 
          <Route index path="users" element={<UsersTable />} />  
          <Route index path="roles" element={<Roles />} /> 
          <Route index path="access-keys" element={<AccessKeysTable />} />  
          <Route index path="projects" element={<ProjectTable />} />  
          <Route index path="dsc" element={<DscTable />} />             
          <Route index path="dsc/register" element={<DscRegister />} />    
          <Route index path="signtest" element={<SignTest />} />  
          <Route index path="digital-sign" element={<DigiSignSingle />} />           
        </Route>
    );
};

export default DashRoutes;